import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useCookies } from 'react-cookie';
import IsTestModeContext from '../../../../contextProviders/IsTestModeContext';
import translate from '../../../translate';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

const renderItem = (t, isTestMode = false, key = '') => (
  <span>
    <i
      key={`demo-icon-${key}`}
      className={
        isTestMode
          ? 'fa fa-exclamation-circle text-warning'
          : 'fa fa-check-circle text-success'
      }
      style={{ marginRight: '5px' }}
    />
    {isTestMode ? t('mode_test') : t('mode_live')}
  </span>
);

function DemoSelector(props) {
  const { t } = props;
  const { loggedUser } = useContext(LoggedUserContext);
  const isAdmin = loggedUser?.role === 'admin';
  const [_, setCookie] = useCookies(['isTestMode']);
  const { isTestMode: isNowTestMode, isTrial } = useContext(IsTestModeContext);

  const handleSelect = (isTestMode = false) => {
    let domain = window.location.hostname;
    const urlElements = domain.split('.');

    if (urlElements.length > 2) {
      domain = `.${urlElements[urlElements.length - 2]}.${
        urlElements[urlElements.length - 1]
      }`;
    }

    const expires = new Date(Date.now() + 1000 * 60 * 10); // 10 minutes from now

    setCookie('isTestMode', isTestMode, {
      domain,
      path: '/',
      expires,
      httpOnly: false,
    });
    window.location.reload();
  };

  // Hide component if not in trial mode
  if ((!isTrial && !isNowTestMode) || !isAdmin) return null;

  return (
    <li className="m-nav__item">
      <div
        className="dropdown"
        style={{
          position: 'relative',
          height: '100%',
          top: '26%',
          marginRight: '30%',
        }}
      >
        <button
          className="btn btn-light dropdown-toggle"
          type="button"
          id="dropdownDemoMode"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          {renderItem(t, isNowTestMode, `DEMO-${isNowTestMode}`)}
        </button>
        <div className="dropdown-menu">
          <button
            type="button"
            className="dropdown-item"
            onClick={() => handleSelect(false)}
          >
            {renderItem(t, false, 'DEMO-incorrect')}
          </button>
          <button
            type="button"
            className="dropdown-item"
            onClick={() => handleSelect(true)}
          >
            {renderItem(t, true, 'DEMO-correct')}
          </button>
        </div>
      </div>
    </li>
  );
}

DemoSelector.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(DemoSelector);
